import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { OutsourcingContractPdfPreviewRequestEntity, OutsourcingContractPdfRequestEntity } from 'src/entities/OutsourcingContractPdf.entity';
import requestUtil from 'src/utils/request.util';

const requestPath = '/api/v4/outsourcing_contract_pdf';

// APIレスポンスの型定義
export type GeneratePdfResponse = {
  data: ArrayBuffer; // バイナリデータ
  headers: {
    'content-disposition'?: string;
    'x-suggested-filename'?: string;
  };
};

export const useMutationOutsourcingContractPdf = () => {
  const queryClient = useQueryClient();
  return {
    generate: useMutation(
      (entity: OutsourcingContractPdfRequestEntity) => {
        const settingsArray = Object.entries(entity.outsourcingContractSettings).map(([orderId, settings]) => ({
          ...settings,
          orderId: Number(orderId),
        }));
        const modifyedEntity = {
          ...entity,
          outsourcingContractSettings: settingsArray,
        };
        return axios.post<GeneratePdfResponse>(
          requestPath,
          requestUtil.convertKeysToSnakeCase(modifyedEntity),
          {
            responseType: 'arraybuffer' as const,
          }
        );
      },
    ),
    create: useMutation(
      (entity: OutsourcingContractPdfPreviewRequestEntity) => axios.post(
        requestPath,
        requestUtil.convertKeysToSnakeCase(entity),
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ),
    ),
  };
};
